import { render, staticRenderFns } from "./AffiliatesReferredElement.vue?vue&type=template&id=6fdba7ec&scoped=true"
import script from "./AffiliatesReferredElement.vue?vue&type=script&lang=js"
export * from "./AffiliatesReferredElement.vue?vue&type=script&lang=js"
import style0 from "./AffiliatesReferredElement.vue?vue&type=style&index=0&id=6fdba7ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdba7ec",
  null
  
)

export default component.exports